import { Component, ElementRef, AfterViewInit, ViewChild, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { Graph, ModelXmlSerializer, CellHighlight, VertexHandler, EllipseShape, 
  KeyHandler, CellRenderer, Codec, xmlUtils,
  Clipboard, UndoManager, InternalEvent,
  SvgCanvas2D, ImageExport,
  StencilShapeRegistry,
  StencilShape,
  DragSource, GraphDataModel, CellHandle, SelectionHandler
} from '@maxgraph/core';

import { HelperModule } from '../back-office/modules/helper.module';
import { ApiServiceModule } from '../back-office/modules/api-service.module';
import { SharedService } from '../back-office/modules/shared-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EnovskyDrawModalComponent } from './enovsky-draw-modal/enovsky-draw-modal.component';
@Component({
  selector: 'app-enovsky-draw',
  templateUrl: './enovsky-draw.component.html',
  styleUrls: ['./enovsky-draw.component.scss']
})
export class EnovskyDrawComponent implements AfterViewInit{
  constructor(
      private renderer: Renderer2,
      private elRef:ElementRef,
      public cdRef: ChangeDetectorRef,
      public helper: HelperModule,
      public dialog: MatDialog,
      private apiService: ApiServiceModule,
      private sharedService: SharedService,
      public sanitizer: DomSanitizer) {}
  @ViewChild('graphContainer', { static: true }) graphContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('paletteContainer', { static: true }) paletteContainer!: ElementRef<HTMLDivElement>;
  graph!: Graph;
  templateCell: any; // store root template
  grapthTemp = `<mxGraphModel dx="80" dy="60" grid="1" gridSize="10" guides="1"
  tooltips="1" connect="1" arrows="1" fold="1"
  page="1" pageScale="1" pageWidth="827" pageHeight="1169">

  <root>
    <mxCell id="0"/>
    <mxCell id="1" parent="0"/>

    <!-- Inclined plane (triangle) -->
    <mxCell id="2"
      value=""
      style="shape=triangle;direction=north;fillColor=transparent;strokeColor=#000000;strokeWidth=2;"
      vertex="1"
      parent="1">
      <mxGeometry x="200" y="200" width="200" height="120" as="geometry"/>
    </mxCell>

    <!-- Mass block -->
    <mxCell id="3"
      value="m"
      style="shape=rectangle;fillColor=transparent;strokeColor=#000000;strokeWidth=2;align=center;verticalAlign=middle;"
      vertex="1"
      parent="1">
      <mxGeometry x="330" y="170" width="50" height="40" as="geometry"/>
    </mxCell>

  </root>
</mxGraphModel>

`
  xmlStrings = [
    {
      key: 'resistor_2',
      name: 'Variable Resistor 2',
      xml: `<shape aspect="variable" h="60" name="Variable Resistor 2" strokewidth="inherit" w="100">
    <connections>
        <constraint name="in" perimeter="0" x="0" y="0.5"/>
        <constraint name="out" perimeter="0" x="1" y="0.5"/>
    </connections>
    <foreground>
        <path>
            <move x="0" y="30"/>
            <line x="18" y="30"/>
            <line x="22" y="20"/>
            <line x="30" y="40"/>
            <line x="38" y="20"/>
            <line x="46" y="40"/>
            <line x="54" y="20"/>
            <line x="62" y="40"/>
            <line x="70" y="20"/>
            <line x="78" y="40"/>
            <line x="82" y="30"/>
            <line x="100" y="30"/>
            <move x="30" y="60"/>
            <line x="70" y="0"/>
            <move x="57" y="10"/>
            <line x="70" y="0"/>
            <line x="66.5" y="15.5"/>
        </path>
        <fillstroke/>
    </foreground>
</shape>`
    },
    {
      key: 'attenuator',
      name: 'Attenuator',
      xml: `<shape aspect="variable" h="60" name="Attenuator" strokewidth="inherit" w="100">
    <connections>
        <constraint name="in" perimeter="0" x="0" y="0.5"/>
        <constraint name="out" perimeter="0" x="1" y="0.5"/>
    </connections>
    <background>
        <path>
            <move x="0" y="30"/>
            <line x="18" y="30"/>
            <line x="22" y="20"/>
            <line x="30" y="40"/>
            <line x="38" y="20"/>
            <line x="46" y="40"/>
            <line x="54" y="20"/>
            <line x="62" y="40"/>
            <line x="70" y="20"/>
            <line x="78" y="40"/>
            <line x="82" y="30"/>
            <line x="100" y="30"/>
            <move x="50" y="0"/>
            <line x="50" y="60"/>
        </path>
    </background>
    <foreground>
        <fillstroke/>
    </foreground>
</shape>`
    },
    {
      key: 'magnetoresistor',
      name: 'Magnetoresistor',
      xml: `<shape aspect="variable" h="60" name="Magnetoresistor" strokewidth="inherit" w="100"> <connections> <constraint name="in" perimeter="0" x="0" y="0.5"/> <constraint name="out" perimeter="0" x="1" y="0.5"/> </connections> <foreground> <path> <move x="0" y="30"/> <line x="18" y="30"/> <line x="22" y="20"/> <line x="30" y="40"/> <line x="38" y="20"/> <line x="46" y="40"/> <line x="54" y="20"/> <line x="62" y="40"/> <line x="70" y="20"/> <line x="78" y="40"/> <line x="82" y="30"/> <line x="100" y="30"/> <move x="30" y="60"/> <line x="70" y="0"/> <move x="45" y="45"/> <line x="55" y="60"/> <move x="55" y="45"/> <line x="45" y="60"/> </path> <fillstroke/> </foreground> </shape>`
    },
    {
      key: 'galvanometer',
      name: 'Galvanometer',
      xml: `<shape aspect="fixed" h="90" name="Galvanometer" strokewidth="inherit" w="90">
		<connections>
			<constraint name="N" perimeter="0" x="0.5" y="0"/>
			<constraint name="S" perimeter="0" x="0.5" y="1"/>
			<constraint name="W" perimeter="0" x="0" y="0.5"/>
			<constraint name="E" perimeter="0" x="1" y="0.5"/>
			<constraint name="NW" perimeter="0" x="0.145" y="0.145"/>
			<constraint name="SW" perimeter="0" x="0.145" y="0.855"/>
			<constraint name="NE" perimeter="0" x="0.855" y="0.145"/>
			<constraint name="SE" perimeter="0" x="0.855" y="0.855"/>
		</connections>
		<background>
    <fillstroke/>
			<ellipse h="90" w="90" x="0" y="0"/>
		</background>
		<foreground>
			<fillstroke/>
			<path>
				<move x="45" y="77"/>
				<line x="45" y="13"/>
				<move x="40" y="27"/>
				<line x="45" y="13"/>
				<line x="50" y="27"/>
			</path>
			<fillstroke/>
		</foreground>
	</shape>`
    },
    {
      key: 'ampermeter',
      name: 'Ampermeter',
      xml: `<shape aspect="fixed" h="90" name="Ampermeter" strokewidth="inherit" w="90">
		<connections>
			<constraint name="N" perimeter="0" x="0.5" y="0"/>
			<constraint name="S" perimeter="0" x="0.5" y="1"/>
			<constraint name="W" perimeter="0" x="0" y="0.5"/>
			<constraint name="E" perimeter="0" x="1" y="0.5"/>
			<constraint name="NW" perimeter="0" x="0.145" y="0.145"/>
			<constraint name="SW" perimeter="0" x="0.145" y="0.855"/>
			<constraint name="NE" perimeter="0" x="0.855" y="0.145"/>
			<constraint name="SE" perimeter="0" x="0.855" y="0.855"/>
		</connections>
		<background>
			<ellipse h="90" w="90" x="0" y="0"/>
		</background>
		<foreground>
			<fillstroke/>
			<path>
				<move x="25" y="75"/>
				<line x="65" y="15"/>
			</path>
			<stroke/>
			<path>
				<move x="52" y="25"/>
				<line x="65" y="15"/>
				<line x="61.5" y="30.5"/>
				<close/>
			</path>
			<fillstroke/>
		</foreground>
	</shape>`
    }

  ]
  ngAfterViewInit(): void {
    this.initGraph();
    const serializer = new ModelXmlSerializer(this.graph.getDataModel());
    //serializer.import(this.grapthTemp);
    this.registerStencils();
    this.allowExternalDraggedImage();
    

    window.parent.postMessage({ type: "EDITOR_READY" }, "*");
    window.addEventListener("message", (event: MessageEvent) => {
      if (event.data?.type === "SEND_INIT_DATA") {
        const objects = event.data.payload;
        if (!objects || objects.length === 0) return;
        objects.forEach((diagramData:any) => {
          serializer.import(diagramData);
        });
      }
      if (event.data?.type === "REQUEST_RESULT_DATA") {
        const codec = new Codec();
        const node = codec.encode(this.graph.model);
        const xml = xmlUtils.getXml(node!);
        const svgData = this.exportGraphToSvg();
        window.parent.postMessage({ type: "SEND_RESULT_DATA", xml: xml, svg_data: svgData}, "*");
      }
    });
  }
  initGraph() {
    this.graphContainer.nativeElement.tabIndex = 0;
    // Disable default context menu
    InternalEvent.disableContextMenu(this.graphContainer.nativeElement);

    // Initialize graph
    this.graph = new Graph(this.graphContainer.nativeElement);
    this.graph.setConnectable(true);
    this.graph.setPanning(true);
    this.graph.setCellsResizable(true);
    this.graph.setCellsMovable(true);
    this.graph.setCellsSelectable(true);
    this.graph.setGridEnabled(false);
    this.graph.setDropEnabled(true);
    this.graph.setEnabled(true);
    this.graph.getStylesheet().getDefaultVertexStyle().rotatable = true;
    VertexHandler.prototype.isRotationHandleVisible = function () {
      return true;
    };
    
    this.graph.singleSelection = false;
    CellHighlight.prototype.highlightColor = '#888888'; // gray
    CellHighlight.prototype.strokeWidth = 3;
    CellHighlight.prototype.dashed = false;
    this.graph.setHtmlLabels(false);

    const stylesheet = this.graph.getStylesheet();

    const defaultVertexStyle = stylesheet.getDefaultVertexStyle();
    defaultVertexStyle.strokeWidth = 2; 
    const defaultEdgeStyle = stylesheet.getDefaultEdgeStyle();
    defaultEdgeStyle.strokeWidth = 2;

    this.applySettings();

    (VertexHandler.prototype as any).createSizerShape = function (bounds: any) {
      const shape = new EllipseShape(bounds, '#ffffff', '#0094bc');
      shape.strokeWidth = 1.5;
      return shape;
    };
    this.graph.isValidDropTarget = function(cell, cells, evt) {
      return true;
    };
    
  }
  registerStencils() {
    this.xmlStrings.forEach((shape:any)=>{
      const doc = xmlUtils.parseXml(shape.xml);
      StencilShapeRegistry.add(shape.key, new StencilShape(doc.documentElement));

      const itemDiv = this.renderer.createElement('div');
      itemDiv.className = 'palette-item';
      // Preview container
      const previewDiv = this.renderer.createElement('div');
      previewDiv.className = 'palette-preview';

      // Label
      const label = this.renderer.createElement('div');
      label.className = 'palette-label';
      label.innerText = shape.name;

      itemDiv.appendChild(previewDiv);
      itemDiv.appendChild(label);
      this.paletteContainer.nativeElement.appendChild(itemDiv);

      // 3️⃣ Create preview graph
      const previewGraph = new Graph(previewDiv);
      previewGraph.setEnabled(false);
      previewGraph.setPanning(false);
      previewGraph.setTooltips(false);

      previewGraph.batchUpdate(() => {
        previewGraph.insertVertex(previewGraph.getDefaultParent(), null, '', 10, 10, 30, 15,
          {
            shape: shape.key,
            fillColor: 'transparent',
            strokeColor: 'black'
          }
        );
      });
      // 🔹 Manual center scaling
      const bounds = previewGraph.getGraphBounds();
      const scale = Math.min(previewDiv.clientWidth / bounds.width, previewDiv.clientHeight / bounds.height) * 0.8;

      const xOffset = (previewDiv.clientWidth / scale - bounds.width) / 2;
      const yOffset = (previewDiv.clientHeight / scale - bounds.height) / 2;

      previewGraph.view.scaleAndTranslate(scale, -bounds.x + xOffset, -bounds.y + yOffset);
      // 4️⃣ Make draggable
      const ds = new DragSource(itemDiv, (graph, evt, target, x, y) => {});
      itemDiv.addEventListener('mousedown', (e:any) => {
        const upHandler = (evt: MouseEvent) => {
          const graphRect = this.graph.container.getBoundingClientRect();
          if (
            evt.clientX >= graphRect.left &&
            evt.clientX <= graphRect.right &&
            evt.clientY >= graphRect.top &&
            evt.clientY <= graphRect.bottom
          ) {
            const pt = this.graph.getPointForEvent(evt);
            this.graph.insertVertex(
              this.graph.getDefaultParent(), null, '', pt.x, pt.y, 100, 50,
              { shape: shape.key, fillColor: 'none', strokeColor: 'black', rotatable: true }
            );
          }
          document.removeEventListener('mouseup', upHandler);
        };
        document.addEventListener('mouseup', upHandler);
      })
   })
  } 
  allowExternalDraggedImage(){
    this.graph.container.addEventListener('dragover', (evt) => evt.preventDefault());

    this.graph.container.addEventListener('drop', (evt: DragEvent) => {
      evt.preventDefault();
      const files = evt.dataTransfer?.files;
      if (!files || files.length === 0) return;

      const file = files[0];
      if (!['image/png', 'image/jpeg', 'image/svg+xml'].includes(file.type)) {
        this.helper.showToast('Only PNG, JPEG, or SVG files are allowed');
        return;
      }
      const reader = new FileReader();
      reader.onload = (ev: any) => {
        const pt = this.graph.getPointForEvent(evt);
        this.graph.insertVertex(this.graph.getDefaultParent(), null, '', pt.x, pt.y, 200, 100,
          {
            shape: 'image',
            image: ev.target.result,
            aspect: 'fixed', 
            rotatable: true
          }
        );
      };
      reader.readAsDataURL(file);
    });
  }
  addResistor() {
    const parent = this.graph.getDefaultParent();

    this.graph.batchUpdate(() => {
      this.graph.insertVertex(parent, null, '', 40, 40, 80, 20,
        {
          shape: "resistor",
          fillColor: "none",
          strokeColor: "black"
        }
      );
    });
  }
  exportGraphToSvg() {
    const bounds = this.graph.getGraphBounds();
    const view = this.graph.getView();

    const svgRoot = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svgRoot.setAttribute('width', `${bounds.width}`);
    svgRoot.setAttribute('height', `${bounds.height}`);
    svgRoot.setAttribute('viewBox', `${bounds.x} ${bounds.y} ${bounds.width} ${bounds.height}`);

    const svgCanvas = new SvgCanvas2D(svgRoot, true);
    //svgCanvas.setEmbedded(true);

    const exporter = new ImageExport();

    const parent = this.graph.getDefaultParent();
    const state = view.getState(parent);

    if (state) {
      exporter.drawState(state, svgCanvas);
    }

    return {
      image: new XMLSerializer().serializeToString(svgRoot),
      widthPx: bounds.width / view.scale,
      heightPx: bounds.height / view.scale
    };
  }
  addRectangle() {
    const parent = this.graph.getDefaultParent();

    this.graph.batchUpdate(() => {
      this.graph.insertVertex(parent, null, '', 80, 80, 120, 60,
        {
          shape: "rectangle",
          fillColor: "#ffffff",
          strokeColor: "#000000"
        }
      );
    });
  }

  addLine() {
    const parent = this.graph.getDefaultParent();

    this.graph.batchUpdate(() => {
      const v1 = this.graph.insertVertex(parent, null, '', 100, 200, 10, 10);
      const v2 = this.graph.insertVertex(parent, null, '', 250, 200, 10, 10);

      this.graph.insertEdge(parent, null, '', v1, v2, {strokeColor: 'black'});
    });
  }
  loadModal(source:string){
    const cell = this.graph.getSelectionCell();
    let structureData = null;
    let style = null;
    if (cell) {
      structureData = (cell as any).structure;
      style = this.graph.getCellStyle(cell);
    }
    if(source == 'crop_image' && style == null) return;
    let options = ['crop_image'].includes(source)? {
        width: '70%',
        height: '80%',
        position: {top: '30px' },
        data: {source: source, image: style!.image}
    } : 
    {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      panelClass: 'full-screen-modal',
      data: {source: source, structure: structureData}
    }
    const dialogRef = this.dialog.open(EnovskyDrawModalComponent, options as MatDialogConfig<any>);
    
    dialogRef.afterClosed().subscribe(async result => {
      if(result?.status){
        const parent = this.graph.getDefaultParent();
         this.graph.batchUpdate(() => {
          const cell = this.graph.insertVertex(parent, null, '', 80, 80, result.width, result.height,
            {
              shape: 'image',
              image: result.image,
              aspect: 'fixed'
            },
          );
          (cell as any).structure = result.structure;
        });
      } 
    });
  }
  applySettings(){
    const MOVE_STEP = 2;
    const ROTATE_HANDLE_SIZE = 12;
    const ROTATE_HANDLE_OFFSET = 20;
    const model = this.graph.getDataModel();
    const undoManager = new UndoManager();
    

    this.graph.getDataModel().addListener(InternalEvent.UNDO, (sender:any, evt:any) => {
      undoManager.undoableEditHappened(evt.getProperty('edit'));
    });

    this.graph.getView().addListener(InternalEvent.UNDO, (sender:any, evt:any) => {
      undoManager.undoableEditHappened(evt.getProperty('edit'));
    });

    // -------------------------
    // KEYBOARD SHORTCUTS
    // -------------------------
    const keyHandler = new KeyHandler(this.graph);

    // Delete
    keyHandler.bindKey(46, () => {
      this.graph.removeCells();
    });
    // BACKSPACE (important for Mac)
    keyHandler.bindKey(8, () => {
      this.graph.removeCells();
    });

    // Ctrl + C
    keyHandler.bindKey(67, () => {
      Clipboard.copy(this.graph);
    });

    // Ctrl + V
    keyHandler.bindKey(86, () => {
      Clipboard.paste(this.graph);
    });

    // Ctrl + X
    keyHandler.bindKey(88, () => {
      Clipboard.cut(this.graph);
    });

    // Ctrl + Z (Undo)
    keyHandler.bindKey(90, () => {
      undoManager.undo();
    });

    // Ctrl + Y (Redo)
    keyHandler.bindKey(89, () => {
      undoManager.redo();
    });

    // Ctrl + A (Select All)
    keyHandler.bindKey(65, () => {
      this.graph.selectAll();
    });

    const moveCells = (dx: number, dy: number) => {
      const cells = this.graph.getSelectionCells();
      if (!cells || cells.length === 0) return;

      model.beginUpdate();
      try {
        cells.forEach(cell => {
          if (cell.vertex || cell.edge) { // works in @maxgraph/core
            const geo = cell.geometry;
            if (geo) {
              const newGeo = geo.clone();
              newGeo.x += dx;
              newGeo.y += dy;
              model.setGeometry(cell, newGeo);
            }
          }
        });
      } finally {
        model.endUpdate();
      }
    };
    const getStep = (evt: KeyboardEvent) => evt.shiftKey ? MOVE_STEP * 5 : MOVE_STEP;

    keyHandler.bindKey(37, (evt:any) => { evt.preventDefault(); moveCells(-getStep(evt), 0); }); // Left
    keyHandler.bindKey(38, (evt:any) => { evt.preventDefault(); moveCells(0, -getStep(evt)); }); // Up
    keyHandler.bindKey(39, (evt:any) => { evt.preventDefault(); moveCells(getStep(evt), 0); }); // Right
    keyHandler.bindKey(40, (evt:any) => { evt.preventDefault(); moveCells(0, getStep(evt)); }); // Down

  

    // Prevent browser default shortcuts (important)
    this.graphContainer.nativeElement.addEventListener('keydown', (e:any) => {
      if (e.ctrlKey) {
        e.preventDefault();
      }
    });
    setTimeout(() => {
      this.graphContainer.nativeElement.focus();
    }, 0);
    this.graphContainer.nativeElement.addEventListener('click', () => {
      this.graphContainer.nativeElement.focus();
    });

  }

  startCropMode(cell: any) {
  const view = this.graph.getView();
  const state = view.getState(cell);
  if (!state || !state.shape?.node) return;

  const svgImage = state.shape.node as SVGImageElement;
  const bbox = svgImage.getBBox();

  const overlayPane = view.getOverlayPane();

  const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  rect.setAttribute('x', bbox.x.toString());
  rect.setAttribute('y', bbox.y.toString());
  rect.setAttribute('width', bbox.width.toString());
  rect.setAttribute('height', bbox.height.toString());
  rect.setAttribute('fill', 'rgba(0,0,0,0.3)');
  rect.setAttribute('stroke', '#1a73e8');
  rect.setAttribute('stroke-width', '2');
  rect.style.cursor = 'crosshair';

  overlayPane.appendChild(rect);

  let startX = 0;
  let startY = 0;
  let dragging = false;

  const onMouseDown = (e: MouseEvent) => {
    dragging = true;
    startX = e.clientX;
    startY = e.clientY;
  };

  const onMouseMove = (e: MouseEvent) => {
    if (!dragging) return;

    const dx = e.clientX - startX;
    const dy = e.clientY - startY;

    const newWidth = Math.max(10, dx);
    const newHeight = Math.max(10, dy);

    rect.setAttribute('width', newWidth.toString());
    rect.setAttribute('height', newHeight.toString());
  };

  const onMouseUp = () => {
    if (!dragging) return;
    dragging = false;

    this.applyClipPath(svgImage, rect);

    cleanup();
  };

  const cleanup = () => {
    overlayPane.removeChild(rect);
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
  };

  rect.addEventListener('mousedown', onMouseDown);
  document.addEventListener('mousemove', onMouseMove);
  document.addEventListener('mouseup', onMouseUp);

  // ESC cancel
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') cleanup();
  });
}
applyClipPath(imageNode: SVGImageElement, cropRect: SVGRectElement) {
  const svg = imageNode.ownerSVGElement;
  if (!svg) return;

  const defs = svg.querySelector('defs') || svg.insertBefore(
    document.createElementNS('http://www.w3.org/2000/svg', 'defs'),
    svg.firstChild
  );

  const clipId = 'clip-' + Math.random().toString(36).substring(2);

  const clipPath = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
  clipPath.setAttribute('id', clipId);

  const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  rect.setAttribute('x', cropRect.getAttribute('x')!);
  rect.setAttribute('y', cropRect.getAttribute('y')!);
  rect.setAttribute('width', cropRect.getAttribute('width')!);
  rect.setAttribute('height', cropRect.getAttribute('height')!);

  clipPath.appendChild(rect);
  defs.appendChild(clipPath);

  imageNode.setAttribute('clip-path', `url(#${clipId})`);
}



  
}
